import React from 'react';
import styled from 'styled-components';

import { Box, Text } from 'Components/Base';

const Container = styled((props) => <Box backgroundColor="warning" px={2} py={1} {...props} />)`
  width: 54px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BetaBadge = ({ ...props }) => (
  <Container {...props}>
    <Text textStyle="body2" fontWeight="bold">
      {'Beta'}
    </Text>
  </Container>
);

export default BetaBadge;
